import React from 'react';
import { useStyles } from './styles/help-tooltip-styles';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';

export const TooltipWrapper: React.FC<{ tooltip?: JSX.Element }> = ({
  tooltip,
  children,
}) => {
  const classes = useStyles();

  return (
    <>
      {tooltip ? (
        <Tooltip
          title={tooltip}
          classes={{ tooltip: classes.tooltip }}
          placement="bottom-start"
        >
          {
            children as any // because tooltip is stupid
          }
        </Tooltip>
      ) : (
        children
      )}
    </>
  );
};
